export default __webpack_public_path__ + "2fb0970ae15a53feb5adc343f068acba.woff";